import type { AxiosInstance } from 'axios'
import type { ActivityType } from 'src/types/activities'


export class ActivitiesApi {
  api: AxiosInstance

  urls = {
    activityTypes: () => 'activity-types/' as const,
  }

  constructor (api: AxiosInstance) {
    this.api = api
  }

  getActivityTypes = async (): Promise<ActivityType[]> => {
    const response = await this.api.get<ActivityType[]>(this.urls.activityTypes())
    return response.data
  }
}
